import React from 'react';
import { useAuth } from '../hooks/useAuth';

const TAB_LABELS = {
  overview: 'Dashboard', users: 'Users', services: 'Services', products: 'Products',
  bookings: 'Bookings', orders: 'Orders', payments: 'Transactions', subscriptions: 'Subscriptions',
  reports: 'Reports', settings: 'Settings', approvals: 'Approvals', locations: 'Locations', ads: 'Ads',
};

const AdminTopbar = ({ onMenuOpen, activeTab }) => {
  const { user, logout } = useAuth();
  const now = new Date();
  const greeting = now.getHours() < 12 ? 'Good morning' : now.getHours() < 17 ? 'Good afternoon' : 'Good evening';

  return (
    <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-md border-b border-gray-200/80">
      <div className="flex items-center justify-between h-14 px-4 lg:px-6">
        <div className="flex items-center gap-3">
          <button onClick={onMenuOpen} className="lg:hidden p-1.5 rounded-lg hover:bg-gray-100 transition">
            <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5" /></svg>
          </button>
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-[15px] font-semibold text-gray-900">{TAB_LABELS[activeTab] || 'Dashboard'}</h1>
              {activeTab === 'overview' && (
                <span className="hidden sm:inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-emerald-50 text-emerald-700 border border-emerald-200">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 mr-1 animate-pulse" />Live
                </span>
              )}
            </div>
            {activeTab === 'overview' && (
              <p className="text-[11px] text-gray-400 hidden sm:block">{greeting}, {user?.first_name}</p>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2">
          {/* Visit Site */}
          <a href="https://topinfo.rw" target="_blank" rel="noopener noreferrer"
            className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 text-[12px] font-medium text-gray-500 hover:text-gray-700 hover:bg-gray-50 rounded-lg transition">
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" /></svg>
            Visit Site
          </a>

          {/* Profile */}
          <div className="flex items-center gap-2.5 pl-2 border-l border-gray-200">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-gray-700 to-gray-900 flex items-center justify-center text-white text-[11px] font-semibold shadow-sm">
              {user?.first_name?.[0]}{user?.last_name?.[0]}
            </div>
            <div className="hidden sm:block">
              <p className="text-[12px] font-medium text-gray-900 leading-none">{user?.first_name} {user?.last_name}</p>
              <p className="text-[10px] text-gray-400 mt-0.5">Administrator</p>
            </div>
            <button onClick={logout} title="Logout"
              className="p-1.5 rounded-lg hover:bg-red-50 text-gray-400 hover:text-red-500 transition">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" /></svg>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminTopbar;
